import {
  EobControllerApi,
  EobPaymentPostingRequest,
} from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

interface PostPaymentParams {
  eobUuid: string;
  request: EobPaymentPostingRequest;
}

export const usePostPayment = () =>
  useMutationWithLoading(async (params: PostPaymentParams) =>
    new EobControllerApi(getConfigObject()).postPayment(
      params.eobUuid,
      params.request,
      getXtenantId()
    )
  );
